import * as React from 'react';

export function useProductCardPlacement(containerRef: React.RefObject<HTMLDivElement | null>) {
  const pointRef = React.useRef<HTMLDivElement>(null);
  const productCardRef = React.useRef<HTMLAnchorElement>(null);

  React.useEffect(() => {
    //Handle product card placemenet
    if (productCardRef.current && pointRef.current && containerRef.current) {
      const screenPadding = 16;
      const placeholderRect = pointRef.current.getBoundingClientRect();
      const productCardRect = productCardRef.current.getBoundingClientRect();
      const containerRect = containerRef.current.getBoundingClientRect();

      if (productCardRect.right > containerRect.right && productCardRect.top < containerRect.top) {
        productCardRef.current.style.left = 'auto';
        productCardRef.current.style.right = '0';
        productCardRef.current.style.transform = `translate(${
          containerRect.right - placeholderRect.right - screenPadding
        }px, ${productCardRect.height + placeholderRect.height + screenPadding}px)`;
      } else if (productCardRect.right > containerRect.right) {
        productCardRef.current.style.left = 'auto';
        productCardRef.current.style.right = '0';
        productCardRef.current.style.transform = `translateX(${
          containerRect.right - placeholderRect.right - screenPadding
        }px)`;
      } else if (productCardRect.top < containerRect.top) {
        productCardRef.current.style.transform = `translateY(${
          productCardRect.height + placeholderRect.height + screenPadding
        }px)`;
      }
    }
  }, [containerRef]);
  return { pointRef, productCardRef, containerRef };
}
